import { v4 as uuidv4 } from "uuid";
import {
  IThuPhiTheoLopTab,
  IThuPhiTheoLopThongTinBienLai,
} from "../../../model/request/thu-phi/IThuPhiTheoLopTab";
import { IThuPhiTheoLopActionTypes } from "../../action-types/thu-phi/IThuPhiTheoLopActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiTheoLopReducer } from "../../reducer-model/thu-phi/IThuPhiTheoLopReducer";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
const iniTab: IThuPhiTheoLopTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuKhacs: [],
  sinhVienSelectedIds: [],
  idThuChi: 0,
  idlop: 0,
  step: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  thongTinBienLai: {
    so_phieu_group: 0,
    bienLaiPhieuThu: "",
    loaiBienLai: "thu",
    ngayThu: undefined,
  } as IThuPhiTheoLopThongTinBienLai,
};
const iniState: IThuPhiTheoLopReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiTheoLopReducer = (
  state: IThuPhiTheoLopReducer = iniState,
  action: IThuPhiTheoLopActionTypes
): IThuPhiTheoLopReducer => {
  switch (action.type) {
    case "THU_PHI_THEO_LOP_ADD_NEW_TAB":
      const id = uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: [
          {
            ...iniTab,
            title: "Untitled",
            id: id,
          },
          ...state.tabs,
        ],
      };
    case "THU_PHI_THEO_LOP_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_THEO_LOP_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_THEO_LOP_LOAD_MUC_THU_KHAC_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.id_lop &&
            t.idThuChi === action.payload.id_thu_chi
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_LOAD_MUC_THU_KHAC_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_LOAD_MUC_THU_KHAC_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CHANGE_SINH_VIEN_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            let sinhvien_selected_id_news = action.payload.data.filter(
              (item) => !t.sinhVienSelectedIds.includes(item)
            );
            return {
              ...t,
              hinhThucNops: [],
              sinhVienSelectedIds: action.payload.data,
              mucThuKhacs: t.mucThuKhacs.map((g) => {
                if (action.payload.data.includes(g.id_sv)) {
                  if (sinhvien_selected_id_news?.includes(g.id_sv)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(g.so_tien_phai_nop),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.id_lop &&
            t.idThuChi === action.payload.id_thu_chi
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                so_phieu_group: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };

    case "THU_PHI_THEO_LOP_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            return {
              ...t,
              hinhThucNops: [],
              sinhVienSelectedIds: [
                ...t.sinhVienSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id_sv ?? "")
                ),
                action.payload.data > 0
                  ? action.payload.request?.id_sv ?? ""
                  : "",
              ],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.id_sv === action.payload.request.id_sv) {
                    return {
                      ...mtk,
                      so_tien_thuc_nop: action.payload.data,
                    };
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };

    case "THU_PHI_THEO_LOP_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            t.idlop === action.payload.request.id_lop &&
            t.idThuChi === action.payload.request.id_thu_chi
          ) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuKhacs: [],
                sinhVienSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CHANGE_LOP_SELECTED":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...iniTab,
              id: t.id,
              title: action.payload?.other.ten_lop ?? "",
              focusedValue: action.payload.data,
              idlop: action.payload.data.id,
              status: eReducerStatusBase.is_need_reload,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_THEO_LOP_CHANGE_LOAI_THU_CHI_SELECTED":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.tabId) {
            return {
              ...iniTab,
              id: t.id,
              idlop: t.idlop,
              title: t.title,
              focusedValue: t.focusedValue,
              idThuChi: action.payload.data,
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
